
































import { Vue, Component, Prop } from 'vue-property-decorator';
import { EButtonType } from '@getaccept/lib-ui';
import { EAuthenticationStepType } from '@signing-page/authentication/types/enums/authentication-step-type';
import { IAuthenticationStepInput } from '@signing-page/authentication/types/authentication-step-input';
import { IAuthenticationStep } from '@signing-page/authentication/types/authentication-step';
import Consent from '@signing-page/lobby/components/Consent.vue';

@Component({
  components: {
    Consent,
  },
  data: () => ({
    EButtonType,
  }),
})
export default class Consents extends Vue {
  @Prop() consentSteps: IAuthenticationStep[];
  @Prop() submittingResponse: boolean;

  acceptGDPR = false;
  acceptTracking = false;

  get acceptedGDPR(): boolean {
    if (!this.gdprIsActive) {
      return true;
    }
    return this.acceptGDPR;
  }

  get gdprIsActive(): boolean {
    return this.consentSteps.some((step: IAuthenticationStep) => {
      return step.type === EAuthenticationStepType.GdprConsent;
    });
  }

  get trackingConsentIsActive(): boolean {
    return this.consentSteps.some((step: IAuthenticationStep) => {
      return step.type === EAuthenticationStepType.TrackingConsent;
    });
  }

  get authSteps(): IAuthenticationStepInput[] {
    const steps: IAuthenticationStepInput[] = [];
    if (this.gdprIsActive) {
      steps.push({
        type: EAuthenticationStepType.GdprConsent,
        value: this.acceptGDPR ? '1' : '0',
      });
    }

    if (this.trackingConsentIsActive) {
      steps.push({
        type: EAuthenticationStepType.TrackingConsent,
        value: this.acceptTracking ? '1' : '0',
      });
    }
    return steps;
  }

  handleConsentChange(value: boolean, type: EAuthenticationStepType) {
    if (type === EAuthenticationStepType.TrackingConsent) {
      this.acceptTracking = value;
    } else {
      this.acceptGDPR = value;
    }
  }

  handleDecline() {
    this.$emit('decline');
  }

  handleAnswer() {
    if (this.acceptedGDPR) {
      this.$emit('answer', this.authSteps);
    }
  }

  getValue(consentStep: IAuthenticationStep): boolean {
    if (consentStep.type === EAuthenticationStepType.TrackingConsent) {
      return this.acceptTracking;
    }
    return this.acceptGDPR;
  }

  bindEnter({ key }: KeyboardEvent) {
    if (key === 'Enter') {
      this.handleAnswer();
    }
  }

  mounted() {
    document.addEventListener('keydown', this.bindEnter);
  }

  beforeDestroy() {
    document.removeEventListener('keydown', this.bindEnter);
  }
}
